// First-party engagement tracking. Fire-and-forget, anonymous, no PII.
// Sends events to POST /api/track via navigator.sendBeacon (survives unload),
// falling back to keepalive fetch. A random per-browser visitor id lets the
// backend count unique visitors without any login or cookie.
import { API } from "./api";

const VID_KEY = "tv_vid";

function visitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return null;
  }
}

// Read the same visitor id from anywhere (e.g. to stamp outbound /api/go links).
export function getVisitorId() {
  return visitorId();
}

export function track(type, props = {}) {
  try {
    const body = JSON.stringify({
      type,
      vid: visitorId(),
      path: typeof window !== "undefined" ? window.location.pathname : null,
      ref: typeof document !== "undefined" ? document.referrer || null : null,
      ...props,
    });
    const url = `${API}/track`;
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* analytics must never break the app */
  }
}
